/**
 *
 * auto generated interface for Bookit.Data.AvailabilityTypes
 *
 */

export enum AvailabilityTypes {
  NotAvailable = 0,
  AvailableNotBookable = 1,
  FreelyBookable = 2,
  //BookableWApproval = 3,
  ServiceRelated = 4,
  ServiceGroup = 5,
  SuperGroup = 6,
  //FreelyBookableBillable = 7,
  //ApprovalRequiredBillable = 8,
  RequestRelated = 9,
  TrainingProgram = 10,
  LoanableEquipment = 11,
  LectureRoom = 12,
}
export type AvailabilityTypesUnion = keyof typeof AvailabilityTypes;
export const AvailabilityTypesUnionArray: Array<AvailabilityTypesUnion> = [
  'NotAvailable',
  'AvailableNotBookable',
  'FreelyBookable',
  //'BookableWApproval',
  'ServiceRelated',
  'ServiceGroup',
  'SuperGroup',
  //'FreelyBookableBillable',
  //'ApprovalRequiredBillable',
  'RequestRelated',
  'TrainingProgram',
  'LoanableEquipment',
  'LectureRoom',
];
